import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import { config } from '../../config';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';

const Setting = loadable(() => import('./Setting'), { fallback: null });
const Consent = loadable(() => import('./Consent'), { fallback: null });
const ConsentOtp = loadable(() => import('./ConsentOtp'), { fallback: null });
const ConsentComplete = loadable(() => import('./ConsentComplete'), { fallback: null });
const NotFound = loadable(() => import('./Setting'), { fallback: null });

const liffSettingId = config.liff_id.setting;

export default function SettingRoute() {
	return (
		<Routes>
			<Route path="/" element={
				<AuthProvider liffId={liffSettingId}>
					<CheckCMSNewVersionLayer>
						<Setting />
					</CheckCMSNewVersionLayer>
				</AuthProvider>
			} />
			{/* <Route path="/" element={<Setting />} /> */}
			<Route path="consent" element={<Consent />} />
			<Route path="consent-otp" element={<ConsentOtp />} />
			<Route path="consent-complete" element={<ConsentComplete />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}
